import { v4 as uuid } from 'uuid';
import * as d3 from 'd3';
import { PixoSpatial, PixoSpatialCoord } from '../Pixospatial';
import { select } from 'd3';
import { EventEmitter } from '@angular/core';
import { Dict } from 'src/app/types/decorable';
import { GeometryObject, Geometry, GeoJSONObject } from '@turf/turf';
import { ROICorners } from 'src/app/components/draw-pane/rectangle-roi';

export interface IFeatureContext {
  roiGroup?: any;
  polygonGroup?: any;
  segmentGroup?: any;
  pointGroup?: any;
  drawRect?: any;
  container?: any;
  snapPt?: any;
  snapSeg?: any;
  updateHandler(feature: Feature): void;
}

export interface IFeature {
  readonly type: string;
  Remove(): void;
  ToGeoJSONGeom(): GeometryObject | false;
  FromGeoJSONGeom(geom: Geometry): void;
  GetSelectedInfo(): any;
  AddVertex(ptInfo: any, xProp?: string, yProp?: string): void;

}

export class Feature implements IFeature {
  get type(): string {
    return '';
  }
  protected lookup: any = {};
  protected lastSelection?: string;
  protected context: IFeatureContext;
  protected localContext: IFeatureContext = { updateHandler: (feature: Feature) => { this.ContextChanged() } };
  protected groups: Array<any> = [];
  protected vertices = 0;
  protected spatialContext?: PixoSpatial;
  public points: Array<any> = [];

  public get id(): string {
    return this.privateId;
  }
  public get hasVertices(): boolean {
    return this.points.length > 0;
  }

  public get vertexSelected(): boolean {
    if (!this.lookup) {
      return false;
    }
    if (!this.lastSelection) {
      return false;
    }
    if (!this.lookup[this.lastSelection]) {
      return false;
    }
    return (this.lookup[this.lastSelection].type === 'point');
  }


  private privateId: string;
  public selectionChange = new EventEmitter<Dict>();
  public geometryChange = new EventEmitter<Dict>();

  public get geometryCount(): number {
    let length = 0;
    const segments = 'segments';
    if (this[segments] && this[segments].length) {
      length += this[segments].length;
    }
    length += this.points.length;
    return length;
  }
  constructor(context: IFeatureContext, spatialContext: PixoSpatial = null) {
    this.context = context;
    this.spatialContext = spatialContext;
    this.privateId = this.GenerateId();
    this.lookup[this.id] = this;
  }
  SelectFeature() {
    for (const group of this.groups) {
      group.classed('selected', true);
    }
  }
  DeselectFeature() {
    for (const group of this.groups) {
      group.classed('selected', false);
    }
  }
  Select(targetId: string): void {
    if ((this.lastSelection !== null) && (this.lastSelection !== targetId)) {
      if (this.lookup.hasOwnProperty(targetId) === false) {
        return;
      }
      if (this.lookup.hasOwnProperty(this.lastSelection) !== false) {

        const lastSelect = this.lookup[this.lastSelection].ui;
        lastSelect.classed('selected', false);
      }


    }
    this.lastSelection = targetId;
    this.selectionChange.emit({ selectedId: targetId });
    if (!this.lookup[this.lastSelection]) return;
    this.lookup[this.lastSelection].ui.classed('selected', true);
  }
  Deselect() {
    if (!this.lastSelection) return;
    const lastSelect = this.lookup[this.lastSelection].ui;
    if (!lastSelect) return;
    lastSelect.classed('selected', false);
    this.lastSelection = null;
    this.selectionChange.emit({ selectedId: null });

  }
  GenerateId(): string {
    return uuid();
  }

  HandleVertexDrag(event): any {
    if (!this.lastSelection) return;
    if (!this.lookup[this.lastSelection]) return;
    if (this.lookup[this.lastSelection].removed) return;
    const me = this.lookup[this.lastSelection].ui;

    const dx = d3.event.dx;
    const dy = d3.event.dy;

    const newX: number = +me.attr('cx') + dx;
    const newY: number = +me.attr('cy') + dy;

    me.attr('cx', newX);
    me.attr('cy', newY);


    const ptId = me.attr('data-guid');
    if (ptId === undefined) {
      return;
    }
    const ptData = this.lookup[ptId];
    ptData.x = newX;
    ptData.y = newY;
    if (this.spatialContext !== null) {
      (ptData.coord as PixoSpatialCoord).UpdatePixo(newX, newY);
    }
    for (const seg of ptData.segments) {
      if (seg.from.id === ptId) {
        seg.from.x = newX;
        seg.from.y = newY;
        seg.updateUI();
      }
      if (seg.to.id === ptId) {
        seg.to.x = newX;
        seg.to.y = newY;
        seg.updateUI();

      }
    }
    return ptData;
  }
  HandleEndVertexDrag(event) {
    this.HandleVertexDrag(event);
    const targetId = $(event.sourceEvent.target).attr('data-guid');
    if (!this.lookup[targetId]) return;
    if (this.lookup[targetId]?.removed) return;
    this.Select(targetId);

    this.UpdateContextHandler();
  }
  WalkForward(startPoint, endPoint) {
    const points = []
    while (startPoint?.nextSeg() !== undefined) {
      const nextSeg = startPoint.nextSeg();
      if (nextSeg.to)
        points.push(nextSeg.to);
      startPoint = nextSeg.to
      if (startPoint.id === endPoint.id) {
        points.pop();
        return { foundTarget: true, points: points };
      }
    }
    return { foundTarget: false, points: [] }
  }
  WalkBackward(startPoint, endPoint) {
    const points = []
    while (startPoint?.prevSeg() !== undefined) {
      const prevSeg = startPoint?.prevSeg()
      points.push(prevSeg.from);
      startPoint = prevSeg.from;
      if (startPoint.id === endPoint.id) {
        points.pop();
        return { foundTarget: true, points: points };
      }
    }
    return { foundTarget: false, points: points }
  }
  MakeVertex(points: Array<any>, ptGroup: any, ptInfo, xProp: string = 'x', yProp: string = 'y', zProp: string = 'z'): any {
    const pt: any = {};
    pt.type = 'point';
    pt.id = this.GenerateId();
    if (!!ptInfo.x) {
      pt.x = ptInfo[xProp];
      pt.y = ptInfo[yProp];
    }
    if (this.spatialContext.IsPixoSpatialCoord(ptInfo)) {
      const coord = this.spatialContext.SpatialCoord(ptInfo.spatial);
      pt.coord = this.spatialContext.PixoSpatialCoord(coord);
      pt.coord.PostConvert = () => {
        pt.x = pt.coord.pixo.x;
        pt.y = pt.coord.pixo.y;
        pt.updateUI();
      };
    }

    pt.updateUI = () => {
      const oldX = pt.ui.attr('cx');
      const oldY = pt.ui.attr('cy');

      pt.ui.attr('cx', pt.x);
      pt.ui.attr('cy', pt.y);
      for (const seg of pt.segments) {
        seg.updateUI();
      }
      this.PointUpdated(pt, oldX, oldY);
    };
    if (this.spatialContext !== null) {
      if (!pt.coord) {
        const coord = this.spatialContext.PixoPt(pt);
        pt.coord = this.spatialContext.PixoSpatialCoord(coord);
        pt.coord.PostConvert = () => {
          pt.x = pt.coord.pixo.x;
          pt.y = pt.coord.pixo.y;
          pt.updateUI();
        };
      }

    }
    pt.featureId = this.id;
    if (zProp === null) {
      pt.z = ptInfo[zProp];
    }
    pt.index = points.length;
    pt.segments = [];
    pt.ui = ptGroup.append('circle');
    pt.ui.attr('cx', pt.x);
    pt.ui.attr('cy', pt.y);
    pt.ui.attr('r', 8);

    pt.ui.classed('point', true);
    pt.ui.attr('data-guid', pt.id);
    pt.ui.call(d3.drag()
      .on('start', () => {
        const ptId = d3.select(d3.event.sourceEvent.srcElement).attr('data-guid');
        this.Select(ptId);
      })
      .on('end', () => { this.HandleEndVertexDrag(d3.event); this.UpdateContextHandler(); })
      .on('drag', () => { this.HandleVertexDrag(d3.event); this.UpdateContextHandler(); })
    );
    this.lookup[pt.id] = pt;
    pt.ui.on('mousedown', () => {
      this.Select(pt.id);
    });
    pt.removed = false;
    pt.remove = () => {
      pt.removed = true;
      pt.ui.on('.drag', null);
      pt.ui.on('mousedown', null);
      pt.ui.remove();
      delete this.lookup[pt.id];
      const ptI = points.indexOf(pt);
      if (ptI > -1) {
        points.splice(ptI, 1);
      }
      this.UpdateContextHandler();
      return pt;
    };
    pt.removeSegment = (seg) => {
      const segI = pt.segments.indexOf(seg);
      if (segI > -1) {
        pt.segments.splice(segI, 1);
      }
    };
    pt.nextSeg = () => {
      for (const seg of pt.segments) {
        if (seg.from?.id === pt.id) {
          return seg;
        }
      }
      return undefined;
    }
    pt.prevSeg = () => {
      for (const seg of pt.segments) {
        if (seg.to?.id === pt.id) {
          return seg;
        }
      }
      return undefined;
    }
    pt.addSegment = (seg) => {
      if (pt.segments.indexOf(seg) < 0) {
        pt.segments.push(seg);
      }
      if (seg.from?.id === pt.id) {
        pt.toSeg = seg;
      }
      if (seg.to?.id === pt.id) {
        pt.fromSeg = seg;
      }
    };
    pt.updateSegs = () => {
      for (const ptSeg of pt.segments) {
        ptSeg.updateUI();
      }
    };
    pt.clearAccuracy = () => {
      pt.coord.spatial.accuracy = 0;
      pt.updateUI();
    }
    pt.updateContext = () => {
      this.UpdateContextHandler();
    }
    points.push(pt);
    this.vertices = points.length;
    this.ContextChanged();
    this.UpdateContextHandler();
    return pt;
  }
  MakeSegment(points, pointGroup, segments, segmentGroup, fromPt = null, toPt = null, ending: string = 'end'): any {

    if (points.length > 1) {
      if (fromPt === null) {
        fromPt = points[points.length - 2];
      }
      if (toPt === null) {
        toPt = points[points.length - 1];
      }
      const seg: any = {};
      seg.type = 'segment';
      seg.featureId = this.id;
      seg.id = this.GenerateId();
      seg.from = fromPt;
      seg.from.addSegment(seg);
      seg.to = toPt;
      seg.to.addSegment(seg);
      if (ending === 'start') {
        seg.ui = segmentGroup.insert('line', ':first-child');
      } else {
        seg.ui = segmentGroup.append('line');
      }


      seg.updateUI = () => {
        if ((!!seg.from) && (!!seg.to)) {
          const length = this.spatialContext.SpatialDistance(seg.from.coord.spatial, seg.to.coord.spatial, 'meters-m');
          const info: any = {
            x1: seg.from.x,
            y1: seg.from.y,
            x2: seg.to.x,
            y2: seg.to.y,
            class: 'line',
            'data-guid': seg.id
          };

          for (const key in info) {
            if (info.hasOwnProperty(key)) {
              seg.ui.attr(key, info[key]);
            }
          }
        }
      };
      seg.updateUI();

      seg.ui.on('click', () => {
        if (this.lastSelection === seg.id) {
          const mouse = d3.mouse(this.context.container);
          seg.AddVertex(mouse[0], mouse[1]);
        } else {
          this.Select(seg.id);
        }
      });
      if (ending === 'start') {
        const firstSeg = segments[0];
        firstSeg.prevSegment = seg;
        seg.nextSegment = firstSeg;
        seg.prevSegment = null;
        segments.unshift(seg);
        this.UpdateContextHandler();
      } else {
        seg.prevSegment = (segments.length > 0) ? segments[segments.length - 1] : null;
        if (seg.prevSegment !== null) {
          seg.prevSegment.nextSegment = seg;
        }
        seg.nextSegment = null;
        segments.push(seg);
        this.UpdateContextHandler();
      }

      this.lookup[seg.id] = seg;
      seg.AddVertex = (x: number, y: number) => {
        const coord = this.spatialContext.PixoSpatialCoord(this.spatialContext.PixoPt({ x: (x), y: (y) }));
        seg.AddVertexFromCoord(coord);
      }

      seg.AddVertexFromCoord = (coord: PixoSpatialCoord) => {
        const pt = this.MakeVertex(points, pointGroup, coord);
        const clickSeg = seg;
        const oldNextSeg = clickSeg.nextSegment;
        const newSeg = this.MakeSegment(points, pointGroup, segments, segmentGroup, pt, clickSeg.to);

        const segI = segments.indexOf(clickSeg);
        if (segI > -1) {
          segments.splice(segI + 1, 0, segments.pop());
          segments[segments.length - 1].nextSegment = null;
        }
        if (!!oldNextSeg) {
          clickSeg.to.removeSegment(clickSeg);
          clickSeg.to.addSegment(newSeg);
          oldNextSeg.prevSegment = newSeg;
          oldNextSeg.updateUI();
          newSeg.nextSegment = oldNextSeg;
          newSeg.updateUI();

        }
        newSeg.to = clickSeg.to;

        clickSeg.nextSegment = newSeg;
        clickSeg.to = pt;
        clickSeg.to.addSegment(clickSeg);
        clickSeg.updateUI();
        let ptI = points.indexOf(pt);
        if (ptI > -1) {
          points.splice(ptI, 1);
        }
        ptI = points.indexOf(seg.from);
        newSeg.prevSegment = clickSeg;

        pt.addSegment(newSeg);
        if (ptI > -1) {
          points.splice(ptI + 1, 0, pt);
        } else {
          points.push(pt);

        }
        this.VertexAddedTo(pt, clickSeg);
        return pt;
      };
      seg.removed = false;
      seg.remove = () => {
        seg.removed = true;
        seg.ui.on('click', null);
        seg.ui.remove();
        if (seg.nextSegment !== null) {
          seg.nextSegment.prevSegment = seg.prevSegment;
        }
        if (seg.prevSegment !== null) {
          seg.prevSegment.nextSegment = seg.nextSegment;
        }
        if (seg.from !== null) {
          seg.from.removeSegment(seg);
        }
        if (seg.to !== null) {
          seg.to.removeSegment(seg);
        }
        delete this.lookup[seg.id];
        if (!!seg.nextSegment) {
          seg.nextSegment.updateUI();
        }
        if (!!seg.prevSegment) {
          seg.prevSegment.updateUI();
        }
        const segi = segments.indexOf(seg);
        if (segi > -1) {
          segments.splice(segi, 1);
        }
        return seg;
      };
      return seg;
    }

  }
  GetCoordinates(points): Array<any> {
    const coords: Array<any> = [];
    for (const vertex of points) {
      coords.push([vertex.x, vertex.y]);
    }
    return coords;
  }
  RemoveSelected() {
    if (!this.lastSelection) {
      return;
    }
    const item = this.lookup[this.lastSelection];
    if (!item?.type) return;
    if (item.type === 'segment') {
      const points = [item.from, item.to];
      this.Select(points[1].id);
      this.RemoveSelected();
      this.Select(points[0].id);
      this.RemoveSelected();
      this.geometryChange.emit(this);
      return;
    }
    this.lastSelection = null;
    for (const seg of item.segments) {
      if (seg.removed === true) {
        continue;
      }
      if (seg.to === item) {

        if (seg.nextSegment !== null) {
          seg.to = seg.nextSegment.to;
          seg.to.addSegment(seg);
          seg.updateUI();
          seg.nextSegment.remove();

        } else {
          seg.to = null;
          seg.from.removeSegment(seg);
          seg.remove();
        }
        this.Select(seg.from.id);


      } else if (seg.from === item) {
        if (!!seg.prevSegment) {
          if (seg.prevSegment.removed === false) {
            if (item.segments.indexOf(seg.prevSegment) > -1) {
              continue;
            }
          }
          if (seg.prevSegment !== null) {
            seg.prevSegment.to = seg.to;
            seg.to.addSegment(seg.prevSegment);
            seg.prevSegment.updateUI();
          }
        }
        seg.to.removeSegment(seg);

        seg.remove();
        this.Select(seg.to.id);
      }
    }
    item.remove();
    this.PointRemoved(item);
  }
  PointRemoved(pt) {
    // extend Feature and override me as needed;
    this.UpdateContextHandler();
  }
  PointUpdated(pt: any, oldX: number, oldY: number) {
    // extend Feature and override me as needed;
    this.UpdateContextHandler();
  }
  VertexAddedTo(pt, seg) {
    this.UpdateContextHandler();
    this.Select(pt.nextSeg().id);
    //this.Select(pt.id);
  }
  RemovePoints(points) {
    for (let i = points.length - 1; i >= 0; i--) {
      const pt = points[i];
      pt.remove();

    }
    if (this.points.length > 0) return;
    this.lookup = {};
    this.lastSelection = null;
    delete this.context;
    for (const group of this.groups) {
      group.remove();
    }
    this.groups = [];
    this.UpdateContextHandler()

  }
  ContextChanged() {
    if (this.spatialContext === null) { return; }
    for (const pt of this.points) {
      const x = pt.coord.x;
      const y = pt.coord.y;
      (pt.coord as PixoSpatialCoord).UpdateSpatial(pt.coord.spatial.lng, pt.coord.spatial.lat);
      pt.updateUI();

    }
    this.UpdateContextHandler();
    // this.context.updateHandler(this);

  }
  public GetSelectedInfo(): any {
    if (this.lastSelection === null) {
      return null;
    }
    if (!!this.lookup[this.lastSelection]) {
      return this.lookup[this.lastSelection];
    }
    return null;
  }
  public GetGeometry(): Array<any> {
    const geometry = [];
    const segments = 'segments';
    let ctr = -1;
    for (const point of this.points) {
      ctr += 1;
      geometry.push(point);

      if (!!this[segments] && this[segments].length && this[segments].length > ctr) {
        geometry.push(this[segments][ctr]);
      }

    }
    return geometry;
  }
  public IsSelected(geomId: string): boolean {
    return (this.lastSelection === geomId);
  }
  public Remove(): void {
    // do nothing
  }
  UpdateContextHandler() {
    if (this.context) {
      this.geometryChange.emit(this);

      // this.context.updateHandler(this);
    }
  }
  GetSelectedId() {
    return this.lastSelection;
  }
  ToGeoJSONGeom(): GeometryObject | false {
    return false; // override me;
  }
  FromGeoJSONGeom(_1geom: Geometry): void {
    return;
  }
  AddVertex(ptInfo: any, xProp?: string, yProp?: string): void {
    // do nothing; override me
  }
  HasCoord(coord: PixoSpatialCoord) {
    for (const point of this.points) {
      if (point.coord.Equals(coord)) {
        return true;
      }
    }
    return false;
  }
  GetWithinROI(roiCorners: ROICorners): Array<any> {
    if (!this.spatialContext) return [];
    return this.spatialContext.GetPointsInROI(roiCorners, this.points);
  }
  GetWithinPolygon(polygon: GeoJSONObject): Array<any> {
    if (!this.spatialContext) return [];
    return this.spatialContext.GetPointsInPolygon(polygon, this.points)
  }
  ToggleVis(_isOn?: boolean) {

  }
  GetVis(): boolean {
    return false;
  }
}
